module.exports = __webpack_public_path__ + "static/media/Internet.e8da029e.svg";